export const showDialogBoolean = {
  props: {
    value: Boolean
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}